export default "__VITE_ASSET__8da2e95d__"